// A labelled text input in the FormV2 field chrome, controlled by the
// caller. For wizard screens that hold their own state and have no
// react-hook-form context to hang a Controller off.

import {
  FieldError,
  FieldHelper,
  FieldLabel,
  inputClass,
} from "components/FormV2/fields/chrome";

export interface WizardFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string | null;
  helper?: string;
  optional?: boolean;
  autoFocus?: boolean;
}

export default function WizardTextField({
  id,
  label,
  value,
  onChange,
  error,
  helper,
  optional,
  autoFocus,
  type = "text",
  autoComplete,
  inputMode,
  maxLength,
}: WizardFieldProps & {
  type?: "text" | "email";
  autoComplete?: string;
  inputMode?: "text" | "email" | "numeric";
  maxLength?: number;
}) {
  return (
    <div className="min-w-0">
      <FieldLabel text={label} htmlFor={id} optional={optional} />
      <input
        id={id}
        name={id}
        type={type}
        value={value}
        autoComplete={autoComplete}
        inputMode={inputMode}
        maxLength={maxLength}
        autoFocus={autoFocus}
        aria-invalid={error ? true : undefined}
        aria-describedby={error ? `${id}-error` : undefined}
        className={inputClass(Boolean(error))}
        onChange={(event) => onChange(event.target.value)}
      />
      <FieldHelper text={helper} />
      <span id={`${id}-error`}>
        <FieldError message={error ?? undefined} />
      </span>
    </div>
  );
}

/** Five digits, typed or pasted; anything else is dropped as it goes in. */
export function ZipField({
  label = "ZIP code",
  ...props
}: Omit<WizardFieldProps, "label"> & { label?: string }) {
  return (
    <WizardTextField
      {...props}
      label={label}
      inputMode="numeric"
      autoComplete="postal-code"
      maxLength={5}
      onChange={(value) => props.onChange(value.replace(/\D/g, "").slice(0, 5))}
    />
  );
}
